import { defineStore } from 'pinia';
import { ResumeEducation } from '@/types/pages/ResumeEducation';

const initialState: ResumeEducation = {
  school_category_id: undefined,
  school_name: undefined,
  faculty: '',
  graduated_year: undefined,
  graduated_month: undefined,
  graduation_classification_id: 1,
  other_educational_backgrounds: '',
};

export const useResumeEducationStore = defineStore('useResumeEducation.store', {
  state: (): ResumeEducation => ({ ...initialState }),
});
